import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/scrollbar";

import { Autoplay } from "swiper/modules";

import classNames from "classnames/bind";
import styles from "./PerformanceSlider.module.css";
import data from "../data/accident.json";
import AciCard from "./AciCard";

const cx = classNames.bind(styles);

export default function PerformanceSlider() {
  return (
    <Swiper
      modules={[Autoplay]}
      slidesPerView={1}
      slidesPerGroup={1}
      spaceBetween={30}
      breakpoints={{
        // 768px 이상 (태블릿)
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 25,
        },
        // 1280px 이상 (데스크탑)
        1280: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 30,
        },
      }}
      loop={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      touchRatio={0.8}
      grabCursor={true}
      speed={800}
    >
      {data.cases.map((item, index) => (
        <SwiperSlide key={index}>
          <AciCard item={item} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
